module.exports = __webpack_public_path__ + "img/2fad478.jpg";